export const YES7_ANDROID_PACKAGE = "com.yes7tickets.client";
export const YES7_IOS_STORE_URL = 'https://apps.apple.com/br/app/yes7-tickets/id6761767258';
export type AppContinuation = { url: string; openUrl: string; description: string; label: string };

export function getAppContinuation(eventId: string, userAgent: string, platform: string, maxTouchPoints: number): AppContinuation | null {
  if (!/^\d+$/.test(eventId)) return null;
  const android = /Android/i.test(userAgent);
  const ios = /iPhone|iPad|iPod/i.test(userAgent) || (platform === 'MacIntel' && maxTouchPoints > 1);
  if (!android && !ios) return null;
  const openUrl = `yesseventicketsclient://event/${eventId}`;
  return android ? {
    url: buildAndroidEventInstallUrl(eventId), openUrl, label: 'Instalar e continuar',
    description: 'Depois de instalar pela Play Store, abra o aplicativo para continuar neste evento.',
  } : {
    url: YES7_IOS_STORE_URL, openUrl, label: 'Instalar na App Store',
    description: 'Instale o aplicativo. Depois, volte a este link e toque em “Abrir evento no app”.',
  };
}

export function buildAndroidEventInstallUrl(eventId: string | number): string {
  const normalizedEventId = String(eventId).trim();
  if (!/^\d+$/.test(normalizedEventId)) {
    throw new Error("Invalid Yes7 event id");
  }

  const referrer = new URLSearchParams({
    utm_source: "yes7tickets_web",
    utm_medium: "deferred_deep_link",
    utm_campaign: "event_share",
    yes7_event_id: normalizedEventId,
    yes7_path: `/event/${normalizedEventId}`,
  });
  const playStoreUrl = new URL("https://play.google.com/store/apps/details");
  playStoreUrl.searchParams.set("id", YES7_ANDROID_PACKAGE);
  playStoreUrl.searchParams.set("referrer", referrer.toString());
  return playStoreUrl.toString();
}
